import Grid from "components/primitives/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Mui5 from "components/mui5";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import Div from "components/primitives/Div";

interface ConfirmationScreenProps {
  athleteCount: number;
  exerciseCount: number;
  totalUpdates: number;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

function ConfirmationScreen(props: ConfirmationScreenProps) {
  const { athleteCount, exerciseCount, totalUpdates, onConfirm, onCancel, isSubmitting } = props;
  const { t } = useTranslation();

  const summaryItems = useMemo(
    () => [
      { label: t("athlete.bulk_1rm_athletes_label"), value: athleteCount },
      { label: t("athlete.bulk_1rm_exercises_label"), value: exerciseCount },
      { label: t("athlete.bulk_1rm_total_updates_label"), value: totalUpdates },
    ],
    [athleteCount, exerciseCount, totalUpdates, t]
  );

  return (
    <Div sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Div>
        <Typography variant="h3" gutterBottom>
          {t("athlete.bulk_1rm_confirm_title")}
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {t("athlete.bulk_1rm_confirm_description", { athleteCount, exerciseCount })}
        </Typography>
      </Div>
      <Div sx={{ p: 3, bgcolor: "grey.50", borderRadius: 1 }}>
        {summaryItems.map((item, index) => (
          <Div key={index}>
            {index > 0 && <Divider sx={{ my: 2 }} />}
            <Grid
              container
              sx={{
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Grid>
                <Typography variant="body1">{item.label}</Typography>
              </Grid>
              <Grid>
                <Typography variant="h4" color="primary">
                  {item.value}
                </Typography>
              </Grid>
            </Grid>
          </Div>
        ))}
      </Div>
      <Grid
        container
        spacing={2}
        sx={{
          width: "100%",
        }}
      >
        <Grid size={{ xs: 12, sm: 6 }}>
          <Mui5.Button variant="outlined" onClick={onCancel} disabled={isSubmitting} fullWidth>
            {t("global.cancel_button_text")}
          </Mui5.Button>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Mui5.Button variant="contained" onClick={onConfirm} disabled={isSubmitting} fullWidth>
            {isSubmitting ? t("athlete.bulk_1rm_uploading_button_text") : t("global.confirm_button_text")}
          </Mui5.Button>
        </Grid>
      </Grid>
    </Div>
  );
}

export default ConfirmationScreen;
